export const organizationChannelForUser = user => {
  const organizationId = user.organization?.id;
  return `organization:${organizationId}`;
};
